import { Textarea, TextareaProps } from "@mantine/core";
import React, { useRef } from "react";
import { IFocusableFormField } from "@type";

export interface IFormTextAreaProps<Values = Record<string, unknown>>
  extends TextareaProps,
    IFocusableFormField<Values> {}

export const FormTextArea: <Values = Record<string, unknown>>(
  props: IFormTextAreaProps<Values>,
) => JSX.Element = ({ fieldName, parentForm, ...rest }) => {
  const elementRef = useRef<HTMLTextAreaElement>(null);
  parentForm.registerField(fieldName, elementRef);
  return (
    <Textarea
      {...parentForm.getInputProps(fieldName)}
      {...rest}
      ref={elementRef}
    />
  );
};
